import React from 'react';
const IdSetter = (props) => {
    const value = props?.value;
    return <div style={{ '-webkit-user-select': 'text' }}>{value}</div>;
};
export default IdSetter;
